declare namespace $ {

	export class $bog_worm_plot extends $mol_canvas {
		grabbing( ): boolean
		event_down( next?: any ): any
		event_move( next?: any ): any
		event_up( next?: any ): any
		event_off( next?: any ): any
		event_leave( next?: any ): any
		event_wheel( next?: any ): any
		layout_name( ): string
		types( ): Record<string, any>
		kinds( ): Record<string, any>
		weight_min( ): number
		focus( next?: string ): string
		path_from( ): string
		path_to( ): string
		hover( next?: string ): string
		picked( next?: number ): number
		tip( ): string
		tip_x( next?: number ): number
		tip_y( next?: number ): number
		reset( next?: any ): any
		attr( ): ({ 
			'tabindex': number,
			'worm_grabbing': ReturnType< $bog_worm_plot['grabbing'] >,
		})  & ReturnType< $mol_canvas['attr'] >
		event( ): ({ 
			pointerdown( next?: ReturnType< $bog_worm_plot['event_down'] > ): ReturnType< $bog_worm_plot['event_down'] >,
			pointermove( next?: ReturnType< $bog_worm_plot['event_move'] > ): ReturnType< $bog_worm_plot['event_move'] >,
			pointerup( next?: ReturnType< $bog_worm_plot['event_up'] > ): ReturnType< $bog_worm_plot['event_up'] >,
			pointercancel( next?: ReturnType< $bog_worm_plot['event_off'] > ): ReturnType< $bog_worm_plot['event_off'] >,
			pointerleave( next?: ReturnType< $bog_worm_plot['event_leave'] > ): ReturnType< $bog_worm_plot['event_leave'] >,
			wheel( next?: ReturnType< $bog_worm_plot['event_wheel'] > ): ReturnType< $bog_worm_plot['event_wheel'] >,
		})  & ReturnType< $mol_canvas['event'] >
	}
	
}

//# sourceMappingURL=plot.view.tree.d.ts.map